var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "container" } }, [
    _c(
      "div",
      { staticClass: "container_wrap" },
      [
        _c("skp-snb"),
        _vm._v(" "),
        _c("div", { attrs: { id: "contents" } }, [
          _c("div", { staticClass: "mainTop_box" }, [
            _c("header", [
              _c("h3", [_vm._v(_vm._s(_vm.$t("TITLE.HOME.KPI")))])
            ]),
            _vm._v(" "),
            _vm.isChartLoading
              ? _c("div", { staticClass: "row_no_margin" }, [_vm._m(0)])
              : _c(
                  "div",
                  { staticClass: "row_no_margin", attrs: { id: "slide" } },
                  _vm._l(_vm.myChartList, function(chart, idx) {
                    return _c(
                      "div",
                      {
                        staticClass: "col-4 col-sm-auto",
                        on: {
                          dblclick: function($event) {
                            return _vm.goToDetailPage(chart)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "service_block" }, [
                          _c(
                            "div",
                            { staticClass: "chart-block" },
                            [
                              ["IC", "MRC", "CS"].includes(chart.chartType)
                                ? _c("horizontal-chart", {
                                    attrs: {
                                      chart: chart,
                                      settings:
                                        _vm.myChartSettings.rowData[idx],
                                      styles: _vm.chartStyles
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              ["ICO", "MRCO", "QA"].includes(chart.chartType)
                                ? _c("doughnut-chart", {
                                    attrs: {
                                      chart: chart,
                                      settings:
                                        _vm.myChartSettings.rowData[idx],
                                      styles: _vm.chartStyles
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              ["CU", "RE"].includes(chart.chartType)
                                ? _c("vertical-chart", {
                                    attrs: {
                                      chart: chart,
                                      settings:
                                        _vm.myChartSettings.rowData[idx],
                                      styles: _vm.chartStyles
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              ["CC"].includes(chart.chartType)
                                ? _c("polar-chart", {
                                    attrs: {
                                      chart: chart,
                                      settings:
                                        _vm.myChartSettings.rowData[idx],
                                      styles: _vm.chartStyles
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  0
                ),
            _vm._v(" "),
            _c("div", { staticClass: "dots-wrap" }),
            _vm._v(" "),
            !_vm.isChartLoading
              ? _c(
                  "a",
                  {
                    staticClass: "ico_config",
                    attrs: {
                      href: "javascript:",
                      title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                    },
                    on: { click: _vm.btnDashboardConfig }
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.isContentsLoading
            ? _c("div", { staticClass: "mainTop_box mt-20" }, [_vm._m(1)])
            : _c(
                "div",
                { staticClass: "row mainBtm_box" },
                [
                  _c("div", { staticClass: "col-12 service_tab" }, [
                    _c("div", { staticClass: "service_block" }, [
                      _c(
                        "ul",
                        { staticClass: "tab_list" },
                        _vm._l(_vm.myContentsList, function(cont, idx) {
                          return _c(
                            "li",
                            { class: idx === 0 ? "active" : "" },
                            [
                              cont.WORK_KEY === "H"
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "javascript:",
                                        rel: idx + 2
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.HOT.CONTENTS")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.WORK_KEY === "W"
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "javascript:",
                                        rel: idx + 2
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.WORKBOARD")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.WORK_KEY === "S"
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "javascript:",
                                        rel: idx + 2
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.SUPPORT")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.WORK_KEY === "N"
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "javascript:",
                                        rel: idx + 2
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.NEW.UPDATE")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.myContentsList, function(cont, idx) {
                    return [
                      cont.WORK_KEY === "H"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-12 col-sm-12 tab_content"
                            },
                            [
                              idx === _vm.myContentsList.length - 1
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "ico_config",
                                      attrs: {
                                        href: "javascript:",
                                        title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                                      },
                                      on: { click: _vm.btnContentsConfig }
                                    },
                                    [
                                      _c("span", { staticClass: "sr_only" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "service_block" },
                                [
                                  _c("header", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.HOT.CONTENTS")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  !_vm.hotReady
                                    ? _c("fragment", [
                                        _c("ul", { staticClass: "ul_list" }, [
                                          _c("li", { staticClass: "nodata" }, [
                                            _c(
                                              "span",
                                              { staticClass: "loader_box" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "loader" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    : _c("fragment", [
                                        _vm.hotContentsList.length === 0
                                          ? _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              [
                                                _c(
                                                  "li",
                                                  { staticClass: "nodata" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MESSAGE.GLOBAL.NO.DATA"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              _vm._l(
                                                _vm.hotContentsList,
                                                function(content, idx) {
                                                  return _c("li", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "subject"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                "javascript:"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.popHotContents(
                                                                  content,
                                                                  "H"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            content.HOT_TYPE ===
                                                            "R"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textbgbox_recommend"
                                                                  },
                                                                  [_vm._v("R")]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "decodeXSS"
                                                                  )(
                                                                    content.KNOWLEDGE_TITLE
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "tooltip_m"
                                                          },
                                                          [
                                                            content.HOT_TYPE ===
                                                            "R"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textbgbox_recommend"
                                                                  },
                                                                  [_vm._v("R")]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "decodeXSS"
                                                                  )(
                                                                    content.KNOWLEDGE_TITLE
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(content.REG_DT)
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                      ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      cont.WORK_KEY === "W"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-12 col-sm-12 tab_content"
                            },
                            [
                              idx === _vm.myContentsList.length - 1
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "ico_config",
                                      attrs: {
                                        href: "javascript:",
                                        title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                                      },
                                      on: { click: _vm.btnContentsConfig }
                                    },
                                    [
                                      _c("span", { staticClass: "sr_only" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "service_block" },
                                [
                                  _c("header", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.WORKBOARD")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  !_vm.workReady
                                    ? _c("fragment", [
                                        _c("ul", { staticClass: "ul_list" }, [
                                          _c("li", { staticClass: "nodata" }, [
                                            _c(
                                              "span",
                                              { staticClass: "loader_box" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "loader" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    : _c("fragment", [
                                        _vm.workBoardList.length === 0
                                          ? _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              [
                                                _c(
                                                  "li",
                                                  { staticClass: "nodata" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MESSAGE.GLOBAL.NO.DATA"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              _vm._l(
                                                _vm.workBoardList,
                                                function(content, idx) {
                                                  return _c("li", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "subject"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                "javascript:"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.popHotContents(
                                                                  content,
                                                                  "W"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            content.TYPE ===
                                                              1 &&
                                                            content.SHARE_ID !==
                                                              undefined
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textbox_request"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "FIELD.GLOBAL.REQUEST.SHARING"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                  1 &&
                                                                content.IMPORTANCE_YN ===
                                                                  "Y"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_important"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.IMPORTANT"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                  1 &&
                                                                content.MUST_READ_YN ===
                                                                  "Y"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_must"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.MUSTREAD"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                2
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_todo"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.TO.DO"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                3
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_todo"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.TO.DO"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "decodeXSS"
                                                                  )(
                                                                    content.KNOWLEDGE_TITLE
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "tooltip_m"
                                                          },
                                                          [
                                                            content.TYPE ===
                                                              1 &&
                                                            content.SHARE_ID !==
                                                              undefined
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textbox_request"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "FIELD.GLOBAL.REQUEST.SHARING"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                  1 &&
                                                                content.IMPORTANCE_YN ===
                                                                  "Y"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_important"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.IMPORTANT"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                  1 &&
                                                                content.MUST_READ_YN ===
                                                                  "Y"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_must"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.MUSTREAD"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                2
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_todo"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.TO.DO"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : content.TYPE ===
                                                                3
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textcolor_todo"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "[" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "FIELD.GLOBAL.TO.DO"
                                                                          )
                                                                        ) +
                                                                        "]"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "decodeXSS"
                                                                  )(
                                                                    content.KNOWLEDGE_TITLE
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(content.REG_DT)
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                      ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      cont.WORK_KEY === "S"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-12 col-sm-12 tab_content"
                            },
                            [
                              idx === _vm.myContentsList.length - 1
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "ico_config",
                                      attrs: {
                                        href: "javascript:",
                                        title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                                      },
                                      on: { click: _vm.btnContentsConfig }
                                    },
                                    [
                                      _c("span", { staticClass: "sr_only" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "service_block" },
                                [
                                  _c("header", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.SUPPORT")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  !_vm.supReady
                                    ? _c("fragment", [
                                        _c("ul", { staticClass: "ul_list" }, [
                                          _c("li", { staticClass: "nodata" }, [
                                            _c(
                                              "span",
                                              { staticClass: "loader_box" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "loader" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    : _c("fragment", [
                                        _vm.supportList.length === 0
                                          ? _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              [
                                                _c(
                                                  "li",
                                                  { staticClass: "nodata" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MESSAGE.GLOBAL.NO.DATA"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              _vm._l(_vm.supportList, function(
                                                content,
                                                idx
                                              ) {
                                                return _c("li", [
                                                  _c(
                                                    "span",
                                                    { staticClass: "subject" },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: "javascript:"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.popSupport(
                                                                content.KEY,
                                                                content.KEY_TYPE
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          content.STATUS ===
                                                          "Replied"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_replied"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Inquiry"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_check"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Warning"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_warning"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Answered"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_replied"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Commented"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_replied"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "decodeXSS"
                                                                )(content.TITLE)
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "tooltip_m"
                                                        },
                                                        [
                                                          content.STATUS ===
                                                          "Replied"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_replied"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Inquiry"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_check"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Warning"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_warning"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Answered"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_replied"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : content.STATUS ===
                                                              "Commented"
                                                            ? _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "textcolor_replied"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[" +
                                                                      _vm._s(
                                                                        content.STATUS
                                                                      ) +
                                                                      "]"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "decodeXSS"
                                                                )(content.TITLE)
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "date" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(content.REG_DT)
                                                      )
                                                    ]
                                                  )
                                                ])
                                              }),
                                              0
                                            )
                                      ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      cont.WORK_KEY === "N"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-12 col-sm-12 tab_content"
                            },
                            [
                              idx === _vm.myContentsList.length - 1
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "ico_config",
                                      attrs: {
                                        href: "javascript:",
                                        title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                                      },
                                      on: { click: _vm.btnContentsConfig }
                                    },
                                    [
                                      _c("span", { staticClass: "sr_only" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "service_block" },
                                [
                                  _c("header", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FIELD.DASHBOARD.NEW.UPDATE")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  !_vm.newReady
                                    ? _c("fragment", [
                                        _c("ul", { staticClass: "ul_list" }, [
                                          _c("li", { staticClass: "nodata" }, [
                                            _c(
                                              "span",
                                              { staticClass: "loader_box" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "loader" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    : _c("fragment", [
                                        _vm.newUpdateList.length === 0
                                          ? _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              [
                                                _c(
                                                  "li",
                                                  { staticClass: "nodata" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MESSAGE.GLOBAL.NO.DATA"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "ul",
                                              { staticClass: "ul_list" },
                                              _vm._l(
                                                _vm.newUpdateList,
                                                function(content, idx) {
                                                  return _c("li", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "subject"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                "javascript:"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.popNewUpdateContents(
                                                                  content
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            content.ICO_TYPE ===
                                                            "U"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textbgbox_update"
                                                                  },
                                                                  [_vm._v("U")]
                                                                )
                                                              : content.ICO_TYPE ===
                                                                "N"
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "textbgbox_new"
                                                                  },
                                                                  [_vm._v("N")]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "decodeXSS"
                                                                  )(
                                                                    content.KNOWLEDGE_TITLE
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(content.REG_DT)
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                      ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nodata" }, [
      _c("span", { staticClass: "loader_box" }, [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row_no_margin" }, [
      _c("div", { staticClass: "nodata" }, [
        _c("span", { staticClass: "loader_box" }, [
          _c("div", { staticClass: "loader" }, [
            _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6416ff38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6416ff38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/dashboard/Dashboard.vue
// module id = kwT5
// module chunks = 0